import React, { useMemo } from 'react';
import { Divider } from '@mui/material';
import ActionMenuItem from './ActionMenuItem';
export function generateActionsWithDividers(actions) {
  let showSubActionDividers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const arr = [];
  if (!actions || actions.length === 0) {
    return [];
  }
  function pushToArray(action, depth) {
    if (action.priority || action.divider === 'before' || action.divider === 'both') {
      if (depth === 0 || depth >= 1 && showSubActionDividers) {
        arr.push('divider');
      }
    }
    arr.push(action);
    if (action.subActions && action.subActions.length > 0 && depth <= 1) {
      action.subActions.forEach(subAction => pushToArray(subAction, depth + 1));
    }
    if (action.priority || action.divider === 'after' || action.divider === 'both') {
      if (depth === 0 || depth >= 1 && showSubActionDividers) {
        arr.push('divider');
      }
    }
  }
  for (let i = 0; i < actions.length; i++) {
    const action = actions[i];
    pushToArray(action, 0);
  }
  return removeDuplicatesFromActionDividerArray(arr);
}
export function removeDuplicatesFromActionDividerArray(arr) {
  const newArr = [];
  if (!arr || arr.length === 0) {
    return newArr;
  }
  let lastWasDivider = false;
  for (let i = 0; i < arr.length; i++) {
    const child = arr[i];
    if (child === 'divider') {
      if (lastWasDivider || i === 0) {
        continue;
      }
      lastWasDivider = true;
      newArr.push('divider');
      continue;
    }
    lastWasDivider = false;
    newArr.push(child);
  }
  // remove dividers at the beginning of the list
  if (newArr.length > 0 && newArr[0] === 'divider') {
    newArr.shift();
  }
  // remove dividers at the end of the list
  if (newArr.length > 0 && newArr[newArr.length - 1] === 'divider') {
    newArr.pop();
  }
  return newArr;
}
export const ActionMenu = _ref => {
  let {
    actions,
    data,
    showSubActionDividers = false,
    onCloseMenu,
    disabled = false
  } = _ref;
  // compile a list of actions and dividers if the action specified them
  const fullActionArray = useMemo(() => generateActionsWithDividers(actions, showSubActionDividers), [actions]);
  const oneActionHasIcon = useMemo(() => !!actions.find(action => !!action.icon), [actions]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, fullActionArray.map((child, index) => child === 'divider' ? /*#__PURE__*/React.createElement(Divider, {
    key: index + 'divider'
  }) : /*#__PURE__*/React.createElement(ActionMenuItem, {
    key: child.label + index,
    action: child,
    disabled: disabled,
    data: data,
    dedicateSpaceForBlankIcon: oneActionHasIcon,
    onCloseMenu: onCloseMenu
  })));
};
export default ActionMenu;